<template>
  <div>
    <!-- 图片 -->
    <div class="rootDiv" align="center">
      <div class="imageItem">
        <img
          v-bind:src="cardFace"
          style="height: 100%; width: 100%; object-fit: cover"
        />
      </div>
      <!-- 身份信息 -->
      <div>
        <hr />
        <!-- Name -->
        <b-row class="rowItem">
          <b-col cols="1"></b-col>
          <b-col cols="3">
            <label for="input-name">Name</label>
          </b-col>
          <b-col cols="7">
            <label for="input-name">{{ this.name }}</label>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <hr />
        <!-- 电话 -->
        <b-row class="rowItem">
          <b-col cols="1"></b-col>
          <b-col cols="3">
            <label for="input-name">Phone number</label>
          </b-col>
          <b-col cols="7">
            <label for="input-name">{{ this.mobile }}</label>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <hr />
      </div>
      <div align="center" class="actionArea">
        <b-button
          block
          variant="danger"
          style="width: 80%"
          @click="submitOrder()"
          >Upload picture</b-button
        >
      </div>
    </div>
    <!-- 图片上传 -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">Uploading</p>
      </div>
    </div>
    <!-- 提示弹窗 -->
    <b-modal ref="model" title="Tips" ok-title="Ok" cancel-title="Cancel">
      <p>
        {{ this.messageData }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "UploadCardface_xy",
  data() {
    return {
      name: "",
      mobile: "",
      cardFace: "",
      //  订单号
      order: "",
      loading: false, //加载弹窗
      messageData: "",
      status: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 上传图片
    submitOrder() {
      this.showLoading();
      this.getSubmitOrder();
    },
    toOrderPay_Dubai(orderData) {
      this.$router.push({
        name: "OrderPay_Dubai",
        params: {
          imagePath: this.cardFace,
          order: orderData,
        },
      });
    },
    // 加载弹窗
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    showBankConfirm: function () {
      this.$refs["model"].show();
    },
    // 下单接口
    getSubmitOrder() {
      if (this.status == "0") {
        let that = this;
        let dataURL = this.cardFace;
        this.blobToBase64(dataURL, function (base64) {
          let facademd5 = that.$md5(base64);
          let params = {
            customName: that.name,
            customPhone: that.mobile,
            imgBase64: base64,
            md5: facademd5,
          };
          console.log("params--->", params);
          axios
            .post(config.config_DubaiCard.submitOrder, params)
            .then((res) => {
              console.log("res--->", res);
              if (res.data.code == 200) {
                // 图片上传成功
                that.order = res.data.data;
                that.hideLoading();
                that.queryOrder(that.order);
              } else {
                that.hideLoading();
                // 图片上传失败
                that.messageData = res.data.message;
                that.showBankConfirm();
              }
            });
        });
      } else if (this.status == "1") {
        let that = this;
        let dataURL = this.cardFace;
        let facademd5 = that.$md5(dataURL);
        let params = {
          customName: that.name,
          customPhone: that.mobile,
          imgBase64: dataURL,
          md5: facademd5,
        };
        console.log("params--->", params);
        axios.post(config.config_DubaiCard.submitOrder, params).then((res) => {
          console.log("res--->", res);
          if (res.data.code == 200) {
            // 图片上传成功
            that.order = res.data.data;
            that.hideLoading();
            that.queryOrder(that.order);
          } else {
            that.hideLoading();
            // 图片上传失败
            that.messageData = res.data.message;
            that.showBankConfirm();
          }
        });
      }
    },
    // Query
    queryOrder(data) {
      axios
        .get(config.config_DubaiCard.queryOrder + "?" + "orderNo" + "=" + data)
        .then((res) => {
          console.log("res--->", res);
          let resData = res.data;
          if (resData.code == 200) {
            this.toOrderPay_Dubai(this.order);
          } else {
            this.messageData = "No order was found";
            this.showBankConfirm();
          }
        });
    },
    // blob转base64
    blobToBase64(url, callback) {
      var Img = new Image(),
        dataURL = "";
      Img.src = url;
      Img.onload = function () {
        //要先确保图片完整获取到，这是个异步事件
        var canvas = document.createElement("canvas"), //创建canvas元素
          width = Img.width, //确保canvas的尺寸和图片一样
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中
        dataURL = canvas.toDataURL("image/png"); //转换图片为dataURL
        callback(dataURL);
      };
    },
  },
  mounted: function () {
    var destImg = this.$route.params.targetImg;
    this.cardFace = destImg;
    console.log("destImg--->", this.cardFace);
    this.name = this.$route.params.name;
    this.mobile = this.$route.params.mobile;
    this.status = this.$route.params.status;
  },
};
</script>

<style scoped>
.rootDiv {
  position: relative;
  background-color: #f1f2f3;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  width: 100%;
}
.rowItem {
  margin-top: 16px;
}
.imageItem {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/UploadCardface_Dubai.vue